<div class="page-content-inner mat-typography" fxLayout="column">
  <gz-fuel-resource-list fxFlex
                         resourceType="models"
                         [resources]="models"
                         [length]="paginatedModels.totalCount"
                         [finished]="!paginatedModels.hasNextPage()"
                         (pageChange)="getModels($event)">
  </gz-fuel-resource-list>
</div>
